module.exports = __webpack_public_path__ + "img/g.f97f30c0.png";